import { z } from 'zod';
import { BrandDNASchema } from '../brand';

export const ResearchJobInputSchema = z.object({
  brandName: z.string(),
  brandUrl: z.string(),
  scrapedSnippet: z.string(),
  llmModelId: z.string(),
  applyToBrand: z.boolean().default(false),
});
export type ResearchJobInput = z.infer<typeof ResearchJobInputSchema>;

export const ResearchJobOutputSchema = z.object({
  dna: BrandDNASchema,
});
export type ResearchJobOutput = z.infer<typeof ResearchJobOutputSchema>;
